import React from 'react';

const NavDropdownContext = React.createContext({});

export const NavDropdownProvider = NavDropdownContext.Provider;
export const NavDropdownConsumer = NavDropdownContext.Consumer;
